import OriginInvoiceWizard from './origin-invoice-wizard-container';

export default OriginInvoiceWizard;